// extracted by mini-css-extract-plugin
export const page = "style-module--page--Xi6pZ";
export const pageBackground = "style-module--pageBackground--20qB-";
export const pageBackground__image = "style-module--pageBackground__image--eQw6h";